
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import LanguageIcon from '~/components/language/Icon.vue'
import { LanguageCode2 } from '~/assets/ts/utils/i18n'
import SaLink from '~/components/_general/SaLink.vue'

export default Vue.extend({
  name: 'LanguageListItem',
  components: { LanguageIcon },
  props: {
    code: {
      type: String as PropType<LanguageCode2>,
      required: true,
    },
    /**
     * Language name in user's language
     * @example Spanish or Español
     * */
    localizedName: {
      type: String,
      required: true,
    },
    /**
     * Language name in its own language
     * @example Español
     * */
    localizedNameInLanguage: {
      type: String as PropType<TranslateResult>,
      required: true,
    },
    active: {
      type: Boolean,
    },
    /** If provided, the button will be an SaLink instead of a button */
    to: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    SaLink() {
      return SaLink
    },
  },
})
